import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import Footer from '../../Component/Footer/Footer';
import { IMG } from '../../Component/TuroAlternative/shared';
import HeroSection from '../../Component/TuroAlternative/HeroSection';
import IntroSection from '../../Component/TuroAlternative/IntroSection';
import CalloutSection from '../../Component/TuroAlternative/CalloutSection';
import {
  RentDirectBlock,
  RentIdBlock,
  RentAiBlock,
  RentSuccessBlock,
  RentAcademyBlock,
} from '../../Component/TuroAlternative/ProductBlocks';
import InsuranceSection from '../../Component/TuroAlternative/InsuranceSection';
import RoadsideSection from '../../Component/TuroAlternative/RoadsideSection';
import BookingCta from '../../Component/TuroAlternative/BookingCta';
import DisclaimerSection from '../../Component/TuroAlternative/DisclaimerSection';
import '../../Component/TuroAlternative/TuroAlternative.css';

// "Turo alternative" SEO landing page, ported from the v0 Turoalternate page.
// Intentionally header-less (campaign page); the body is the ported landing
// narrative plus the product ecosystem blocks, closed by the site Footer.
const TuroAlternative = () => {
  const { hash } = useLocation();

  // Client-side routing doesn't scroll on its own: honor #anchors (e.g. the
  // form page's back link to #book-strategy), otherwise start at the top.
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [hash]);

  return (
    <>
    <Helmet>
      <title>Turo Alternative for Private & Direct Rentals | Rentid</title>
      <meta
        name="description"
        content="Looking for a Turo alternative? Rentid is the private and direct rental infrastructure for independent operators — branded booking, renter verification, and On Rent and Off Rent private rental insurance and direct rental insurance. Start direct rentals the right way."
      />
      <meta
        name="keywords"
        content="Turo alternative, turo alternate, alternative to Turo, private rental, direct rental, private rental direct rental, private and direct rentals, private rental insurance, direct rental insurance, On Rent insurance, Off Rent insurance, car rental business software, independent rental operator, white label car rental platform"
      />
      <meta property="og:title" content="The Turo Alternative for Private & Direct Rentals | Rentid" />
      <meta
        property="og:description"
        content="Rentid gives independent operators the infrastructure to run private and direct rentals — branded booking, renter verification, and private rental insurance / direct rental insurance On Rent and Off Rent."
      />
      <meta property="og:type" content="website" />
      <link rel="canonical" href="https://www.rentid.io/turo-alternative" />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
    </Helmet>

    <main className="mpa-page">
      <HeroSection />
      <IntroSection />
      <CalloutSection />

      {/* Product ecosystem — order matches the suite logo lineup above */}
      <div id="product-rentdirect" className="mpa-anchor">
        <RentDirectBlock
          logo={`${IMG}/product-logos/rentdirect-white.png`}
          bg={`${IMG}/product-bg/rentdirect.webp`}
          bgSubtle
        />
      </div>
      <div id="product-rentid" className="mpa-anchor">
        <RentIdBlock
          logo={`${IMG}/product-logos/rentid-white.png`}
          bg={`${IMG}/product-bg/rentid.webp`}
        />
      </div>
      <div id="product-rentshield" className="mpa-anchor">
        <InsuranceSection
          logo={`${IMG}/product-logos/rentshield-white.png`}
          bg={`${IMG}/product-bg/rentshield.webp`}
        />
        <RoadsideSection />
      </div>
      <div id="product-rentai" className="mpa-anchor">
        <RentAiBlock
          logo={`${IMG}/product-logos/rentai-white.png`}
          bg={`${IMG}/product-bg/rentai.webp`}
        />
      </div>
      <div id="product-rentsuccess" className="mpa-anchor">
        <RentSuccessBlock
          logo={`${IMG}/product-logos/rentsuccess-white.png`}
          bg={`${IMG}/product-bg/rentsuccess.webp`}
        />
      </div>
      <div id="product-rentacademy" className="mpa-anchor">
        <RentAcademyBlock
          logo={`${IMG}/product-logos/rentacademy-white.png`}
          bg={`${IMG}/product-bg/rentacademy.webp`}
        />
      </div>

      <BookingCta />
      <DisclaimerSection />
    </main>

      <Footer />
    </>
  );
};

export default TuroAlternative;
